import {useEffect, useState} from 'react';

import {copyTextToClipboard} from '@optimaxdev/utils';

/**
 * A hook for copying text with a timeout
 */
export const useCopyWithTimeout = () => {
    const [isCopied, setIsCopied] = useState(false);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;

        if (isCopied) {
            timer = setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        }

        return () => clearTimeout(timer);
    }, [isCopied]);

    const copyText = (text: string) => {
        copyTextToClipboard(text).then(() => {
            setIsCopied(true);
        });
    };

    return {copyText, isCopied};
};
